import { useQueryTravelDetails } from '../../models'

export interface UseTravelRequestDetailPresenterParams {
  uuid: string
}

/**
 * Route-context accessor for consumers that need the detail entity but not
 * its rendered content: the Page breadcrumbs and the `TravelDetailsView` /
 * `TravelEditView` Feature Sets. React Query dedupes the calls with
 * `<TravelDetailsPresenter />` via the shared detail query key.
 */
export const useTravelRequestDetailPresenter = ({
  uuid,
}: UseTravelRequestDetailPresenterParams) => {
  const { travel, isLoading, error } = useQueryTravelDetails({ uuid })

  return {
    data: {
      travel,
    },
    states: {
      isLoading,
      error,
    },
  }
}
